'use strict';
import $ from 'jquery';
import Backbone from 'backbone';
import _ from 'underscore';
import * as globalisation from '../../utilities/globalisation';
import CountriesAndStatesAPI from '../CountriesAndStates/CountriesAndStatesAPI';
import cookies from 'js-cookie';
import config from '../../js/config';
import utilities from '../../js/utilities';
import cartApi from '../../services/CartAPI';

const ProfileUpdateFormView = Backbone.View.extend({
  events: {
    'click #ProfileUpdate-submitButton': 'onSubmit',
    'change': 'validateForm',
  },

  initialize: function() {
    this.countries = [];
    this.$countryMobileInput = this.$el.find('#RegistrationForm-countryMobileForEUC');
    this.initializeCountries();
    this.$submitButton = this.$el.find('#ProfileUpdate-submitButton');
    this.$fullName = this.$el.find('#fullName');
    this.$phoneNumber = this.$el.find('.RegistrationForm-phoneNumber');
    this.$organizationName = this.$el.find('#organizationName');
    this.$organizationWebsite = this.$el.find('#organizationWebsite');
    this.$jobTitle = this.$el.find('#jobTitle');
    this.$market = this.$el.find('#market');
    this.$businessType = this.$el.find('#businessType');
    this.$businessServe = this.$el.find('#businessServe');
    this.$reqErrMesgJobTitle = this.$el.find('#reqErrMesgJobTitle');
    this.$reqErrMesgMarket = this.$el.find('#reqErrMesgMarket');
    this.$reqErrMesgBusinessType = this.$el.find('#reqErrMesgBusinessType');
    this.$reqErrMesgBusinessServe = this.$el.find('#reqErrMesgBusinessServe');
    this.$reqErrMesgJobTitle.hide();
    this.$reqErrMesgMarket.hide();
    this.$reqErrMesgBusinessType.hide();
    this.$reqErrMesgBusinessServe.hide();
    this.$jobTitleLabel = this.$jobTitle.closest('.u-form-input--text').find('label');
    this.$marketLabel = this.$market.closest('.u-form-input--text').find('label');
    this.$businessTypeLabel = this.$businessType.closest('.u-form-input--text').find('label');
    this.$businessServeLabel = this.$businessServe.closest('.u-form-input--text').find('label');
    $('#length, #number, #uppercase, #lowercase, #special-character').addClass('invalid');
    this.selectJobTitleLabel = globalisation.pluraliseAndTranslate('account', 'jobTitleErrorMsg');
    this.selectIndustryLabel = globalisation.pluraliseAndTranslate('account', 'marketErrorMsg');
    this.selectBusinessTypeLabel = globalisation.pluraliseAndTranslate('account', 'businessTypeErrorMsg');
    this.selectBusinessServeLabel = globalisation.pluraliseAndTranslate('account', 'typesofBusinessesErrorMsg');
    this.$jobTitle.on('change', this.eucSelectFields.bind(this));
    this.$market.on('change', this.eucSelectFields.bind(this));
    this.$businessType.on('change', this.eucSelectFields.bind(this));
    this.$businessServe.on('change', this.eucSelectFields.bind(this));
    this.$submitButton.prop('disabled', true);
  },

  initializeCountries: function() {
    let b2bUserData = utilities.sessionStorageLoad('b2busers');
    let countryCode;
    if (b2bUserData && b2bUserData.country) {
      countryCode = b2bUserData.country.isocode;
    }
    CountriesAndStatesAPI.getCmsCountriesAndStates().then(countries => {
      this.countries = countries;
      this.$countryMobileInput[0].innerHTML = '<option value=""></option>';
      countries.forEach(country => {
        this.$countryMobileInput[0].innerHTML += `<option value=${country.Iso2Code}>${country.CountryName}</option>`;
      });
      if (countryCode) {
        this.$countryMobileInput.val(countryCode);
        this.$countryMobileInput.change();
        this.setFocusOnEmptyField();
      }
    });
    if ((b2bUserData && !b2bUserData.eucCustomerInfo) || (b2bUserData && b2bUserData.eucCustomerInfo && b2bUserData.eucCustomerInfo.eucExpired)) {
      this.setFlagInSessionStorage();
    }
  },

  setFlagInSessionStorage() {
    cookies.set('isOnProfileUpdate', true);
    sessionStorage.setItem('isOnProfileUpdate', 'true');
  },

  eucSelectFields: function(e) {
    let selectedValue = e.target.value;
    if (e.target === this.$jobTitle[0] && selectedValue === '') {
      if (this.$el.find('#jobTitle-error').length > 0) {
        this.$el.find('#jobTitle-error').hide();
      }
      this.$reqErrMesgJobTitle.show();
      this.$jobTitle.addClass('is-invalid selectFieldInvalid');
      this.$jobTitleLabel.addClass('is-invalid');
      this.$jobTitle.attr('aria-describedby', 'jobTitle-error');
      this.$jobTitle.attr('aria-invalid', 'true');
      $('#reqErrMesgJobTitle').html(this.selectJobTitleLabel);
    } else {
      if (e.target === this.$jobTitle[0] && selectedValue !== '') {
        this.$reqErrMesgJobTitle.hide();
        this.$jobTitleLabel.removeClass('is-invalid');
        this.$jobTitle.removeClass('is-invalid selectFieldInvalid');
        this.$jobTitle.attr('aria-invalid', 'false');
      }
    }
    if (e.target === this.$market[0] && selectedValue === '') {
      if (this.$el.find('#market-error').length > 0) {
        this.$el.find('#market-error').hide();
      }
      this.$reqErrMesgMarket.show();
      this.$market.addClass('is-invalid selectFieldInvalid');
      this.$marketLabel.addClass('is-invalid');
      this.$market.attr('aria-describedby', 'market-error');
      this.$market.attr('aria-invalid', 'true');
      $('#reqErrMesgMarket').html(this.selectIndustryLabel);
    } else {
      if (e.target === this.$market[0] && selectedValue !== '') {
        this.$reqErrMesgMarket.hide();
        this.$marketLabel.removeClass('is-invalid');
        this.$market.removeClass('is-invalid selectFieldInvalid');
        this.$market.attr('aria-invalid', 'false');
      }
    }
    if (e.target === this.$businessType[0] && selectedValue === '') {
      if (this.$el.find('#businessType-error').length > 0) {
        this.$el.find('#businessType-error').hide();
      }
      this.$reqErrMesgBusinessType.show();
      this.$businessType.addClass('is-invalid selectFieldInvalid');
      this.$businessTypeLabel.addClass('is-invalid');
      this.$businessType.attr('aria-describedby', 'businessType-error');
      this.$businessType.attr('aria-invalid', 'true');
      $('#reqErrMesgBusinessType').html(this.selectBusinessTypeLabel);
    } else {
      if (e.target === this.$businessType[0] && selectedValue !== '') {
        if (this.$el.find('#businessServe-error')) {
          this.$el.find('#businessServe-error').hide();
        }
        this.$reqErrMesgBusinessType.hide();
        this.$businessTypeLabel.removeClass('is-invalid');
        this.$businessType.removeClass('is-invalid selectFieldInvalid');
        this.$businessType.attr('aria-invalid', 'false');
      }
    }
    if (e.target === this.$businessServe[0] && selectedValue === '') {
      if (this.$el.find('#businessServe-error').length > 0) {
        this.$el.find('#businessServe-error').hide();
      }
      this.$reqErrMesgBusinessServe.show();
      this.$businessServe.addClass('is-invalid selectFieldInvalid');
      this.$businessServeLabel.addClass('is-invalid');
      this.$businessServe.attr('aria-describedby', 'businessServe-error');
      this.$businessServe.attr('aria-invalid', 'true');
      $('#reqErrMesgBusinessServe').html(this.selectBusinessServeLabel);
    } else {
      if (e.target === this.$businessServe[0] && selectedValue !== '') {
        this.$reqErrMesgBusinessServe.hide();
        this.$businessServeLabel.removeClass('is-invalid');
        this.$businessServe.removeClass('is-invalid selectFieldInvalid');
        this.$businessServe.attr('aria-invalid', 'false');
      }
    }
  },

  onSubmit: function(e) {
    e.preventDefault();
    let url = window.location.href;
    let params = new URLSearchParams(new URL(url).search);
    let redirectUrl = params.get('url');
    let decodedURL = redirectUrl ? decodeURIComponent(redirectUrl) : undefined;
    let referrer = document.referrer ? JSON.parse(JSON.stringify(document.referrer)): undefined;
    let isSelectFieldsValid = this.validateEUCSelectFields();
    if (!this.$el.valid() || !isSelectFieldsValid) {
      this.setFocusOnEmptyField();
      var isInValidInput = $('span.is-invalid');
      isInValidInput.addClass('error-message-icon');
      isInValidInput.each(function (index, item) {
        item.ariaLabel = globalisation.pluraliseAndTranslate('common', 'errorText') + ', ' + item.innerText;
      });
    } else {
      let profileUpdateResponse = this.updateUserProfile();
      profileUpdateResponse.done((response) => {
        if (response.data.success) {
          cookies.remove('isOnProfileUpdate');
          sessionStorage.removeItem('isOnProfileUpdate');
          cartApi.getLoyaltyUser().then((b2bUserData) => {
            if (b2bUserData) {
              utilities.sessionStorageSave('b2busers', b2bUserData);
            }
          });
          if (decodedURL) {
            window.location.href = decodedURL
          } else if (referrer) {
            window.location.href = referrer
          } else {
            window.location.href = '/';
          }
        }
    });
    }
  },

  updateUserProfile: function() {
    let token = cookies.get(config.cookies.accessToken);
    let postData = {
      fullName: this.$fullName.val(),
      companyName: this.$organizationName.val(),
      companyWebsite: this.$organizationWebsite.val(),
      jobType: this.$jobTitle.val(),
      industry: this.$market.val(),
      business: this.$businessType.val(),
      businessServed: this.$businessServe.val(),
      phoneNumber: this.$phoneNumber.val().replace(/\s+/g, ''),
      country:  this.$countryMobileInput.val()
    };
    return $.ajax({
      type: 'PUT',
      url: '/api/user/profile/update',
      data: postData,
      contentType: 'application/x-www-form-urlencoded',
      headers: { 'authorization': 'Bearer ' + token },
    })
  },

  validateForm() {
    let isSelectFieldsValid = this.validateEUCSelectFields();
    let isInputFieldsValid = this.validateEUCInputFields();
    if (!isSelectFieldsValid || !isInputFieldsValid) {
      var isInValidInput = $('span.is-invalid');
      isInValidInput.addClass('error-message-icon');
      isInValidInput.each(function (index, item) {
        item.ariaLabel = globalisation.pluraliseAndTranslate('common', 'errorText') + ', ' + item.innerText;
      });
      this.$submitButton.prop('disabled', true);
    } else {
      this.$submitButton.prop('disabled', false);
    }
  },

  validateEUCInputFields: function() {
    let isAllInputEUCFieldValid = true;
    this.$el.find('input[required]').each((_, input) => {
      const selectedValue = $(input).val();
      const isValidInput = selectedValue && selectedValue.trim() !== '';
      if (!isValidInput) {
        isAllInputEUCFieldValid = false;
      }
    });
    return isAllInputEUCFieldValid;
  },

  validateEUCSelectFields: function() {
    let isAllSelectEUCFieldValid = true;
    this.$el.find('select[required]').each((_, select) => {
      const selectedValue = $(select).val();
      const isValidSelect = selectedValue && selectedValue.trim() !== '';
      if (!isValidSelect) {
        isAllSelectEUCFieldValid = false;
      }
    });
    return isAllSelectEUCFieldValid;
  },

  setFocusOnEmptyField: function() {
    let focusElm = null;
    if (!$('#fullName').val())
      focusElm = $('#fullName');
    else {
      if (!$('#RegistrationForm-countryMobileForEUC').val())
        focusElm = $('#RegistrationForm-countryMobileForEUC');
      else {
        if (!$('#phoneNumber').val())
          focusElm = $('#phoneNumber');
        else {
          if (!$('#organizationName').val())
            focusElm = $('#organizationName');
          else {
            if (!$('#organizationWebsite').val())
              focusElm = $('#organizationWebsite');
            else {
              if (!$('#jobTitle').val())
                focusElm = $('#jobTitle');
              else {
                if (!$('#market').val())
                  focusElm = $('#market');
                else {
                  if (!$('#businessType').val())
                    focusElm = $('#businessType');
                  else {
                    if (!$('#businessServe').val())
                      focusElm = $('#businessServe');
                  }
                }
              }
            }
          }
        }
      }
    }
    if (focusElm)
    focusElm.focus();
  },
},

{
  create: function($parent) {
    $parent.find('.ProfileUpdateForm').each(function(n, el) {
      new ProfileUpdateFormView({
        el: el
      });
    });
  }
});

module.exports = ProfileUpdateFormView;



// WEBPACK FOOTER //
// ./assets/components/Registration/ProfileUpdateEUC.js